import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const resultAttributes: SearchkitWrapperProps['searchSettings']['result_attributes'] = [
  'url',
  'type',
  'title',
  'field_logo_url',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'type',
    field: 'type',
    type: 'string',
  },
];
